<template lang="pug">
  .category-posts(v-if="section.categories" :class="[spacingTop, spacingBottom]")
    .container.mx-auto.px-12
      .horizontal(v-if="orientation === 'horizontal'")
        // loading(:active="loading || fetching" :is-full-page="false" :height="40" :width="40" color="#95c021")
        .spinner-container(v-if="fetching")
          Spinner(:size="16" :thickness="3")
        .teasers(v-if="loading")
          .teaser.skeleton(v-for="teaser in teasers" :style="style")
            .image
            .text
        .paginated-teasers(v-else)
          .teasers
            .teaser(v-for="teaser in teasers" :style="style")
              Teaser(:teaser="teaser" display="card" :showDate="showDate")
            // .teaser.skeleton(:style="style")
            //   .image
            //   .text
          Pagination(
            v-if="pageInfo && pageInfo.lastPage > 1"
            :last-page="pageInfo.lastPage"
            :current-page="pageInfo.currentPage"
            nav-class="pagination flex text-center justify-center"
            @change="changePage"
          )
            span.icon(slot="prev")
              font-awesome-icon(icon="arrow-left")
            span.icon(slot="next")
              font-awesome-icon(icon="arrow-right")

              font-awesome-icon(icon="arrow-right")
      .vertical(v-else)
        .container.mx-auto
          // loading(:active="loading || fetching" :is-full-page="false" :height="40" :width="40" color="#95c021")
          // .flex(v-if="loading || fetching")
          //   Spinner(:size="16" :thickness="3")
          .teasers(v-if="loading")
            .teaser.skeleton(v-for="teaser in teasers")
              .image
              .text
          .paginated-teasers(v-else)
            .teasers
              .teaser(v-for="teaser in teasers")
                Teaser(:teaser="teaser" display="row")
              // .teaser.skeleton
              //   .image
              //   .text
          
          Pagination(
            v-if="postsPerPage > 1 && pageInfo && pageInfo.lastPage > 1"
            :last-page="pageInfo.lastPage"
            :current-page="pageInfo.currentPage"
            nav-class="pagination block"
            @change="changePage"
          )
            span.icon(slot="prev")
              font-awesome-icon(icon="arrow-left")
            span.icon(slot="next")
              font-awesome-icon(icon="arrow-right")

</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import store from '@/store';
import { get } from '@/helpers';

// import Loading from 'vue-loading-overlay';
import Teaser from './Teaser';

import Pagination from '@/components/Pagination';

export default {
    name: 'CategoryPosts',
    props: {
        section: {
            type: Object,
            required: true
        },
        perPage: {
            type: Number,
            default: 5
        },
        orientation: {
            type: String,
            default: 'vertical'
        }
    },
    data: () => {
        return {
            fetching: false,
            currentPage: 1
        };
    },
    components: {
        // Loading,
        Teaser,
        Pagination
    },
    watch: {
        perPage() {
            this.fetching = true;
            this.refetch();
        }
    },
    computed: {
        s() {
            return this.sections.findIndex(el => el.id === this.section.id);
        },
        loading() {
            return get(this.section, 'teasers.loading');
        },
        teasers() {
            let teasers = [];
            if (this.loading) {
                if (this.orientation === 'horizontal') teasers = new Array(this.perPage);
                else teasers = new Array(3);
            } else {
                teasers = get(this.section, 'teasers.items');
            }

            return teasers;
        },

        settings() {
            return get(this.section, 'settings');
        },

        postsPerPage() {
            let perPage = 5;
            if (!this.settings) return perPage;
            const qty = this.settings.find(setting => setting.key === 'postsPerPage');

            if (qty) {
                perPage = qty.value;
            }
            return perPage;
        },

        pageInfo() {
            return get(this.section, 'teasers.pageInfo');
        },

        style() {
            return {
                width: `calc(${100 / this.perPage}% - 20px)`
            };
        },

        spacingTop() {
            let spacingTop = 'spacingTopStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingTop');
                if (setting && setting.value !== undefined) spacingTop = setting.value;
            }
            return spacingTop;
        },

        spacingBottom() {
            let spacingBottom = 'spacingBottomStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingBottom');
                if (setting && setting.value !== undefined) spacingBottom = setting.value;
            }
            return spacingBottom;
        },

        ...mapGetters({
            sections: 'sections'
            // cms: 'CMS'
        })
    },
    methods: {
        refetch() {
            const cms = store.getters.CMS.id;
            const tags = this.section.tags.map(tag => tag.id);

            const payload = {
                pageInfo: {
                    currentPage: this.currentPage,
                    perPage: this.postsPerPage
                },
                filters: [
                    {
                        key: 'categories',
                        in: this.section.categories.map(category => category.id)
                    },
                    {
                        key: 'cms',
                        match: cms
                    },
                    {
                        key: 'tags',
                        in: tags
                    }
                ]
            };
            this.fetchTeasers(payload)
                .then(teasers => this.insertTeasers({ s: this.s, teasers }))
                .finally(() => (this.fetching = false));
        },
        changePage(currentPage) {
            // this.updateTeasersLoading({ s: this.s, value: false })
            this.fetching = true;
            this.currentPage = currentPage;
            this.refetch();
        },
        ...mapMutations({
            updateTeasersLoading: 'updateCategoryPostTeasersLoading',
            insertTeasers: 'insertCategoryPostTeasers'
        }),
        ...mapActions({
            fetchTeasers: 'fetchCategoryPostTeasers'
        })
    },
    mounted() {
        const teasers = { loading: true, pagination: {} };
        this.insertTeasers({ s: this.s, teasers });
        this.refetch();
        // this.updateTeasersLoading({ s: this.s, value: false })
    }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variables';
//@import '~empty-state/skeleton';

$skeletonColor: #d8d8d8;
$topicColor: lighten(green, 45%);

.category-posts::v-deep .pagination-container {
    @media (min-width: 767px) {
        margin-top: 20px;
    }

    .pagination {
        .pagination-previous,
        .pagination-next {
            padding-left: 0.3em;
            padding-right: 0.3em;
        }
    }
}

.category-posts .vertical::v-deep .pagination-container {
    margin-top: 50px;
}

.horizontal {
    .teasers {
        display: flex;
        text-align: center;
        .teaser {
            margin: 0 13.33333px;
            margin-bottom: 50px;
            display: flex;
            text-align: initial;

            @media (max-width: 640px) {
                width: 100% !important;
            }

            @media (min-width: 640px) and (max-width: 767px) {
                width: calc(50% - 10px) !important;
            }

            &:first-child {
                margin-left: 0;
            }
            &:last-child {
                margin-right: 0;
            }
            // @include mobile {
            //   width: 100% !important;
            //   max-width: 360px;
            // }

            &.skeleton {
                .image {
                    padding-bottom: 57%; // ca. 9 / 16
                    background: $skeletonColor;
                    border-radius: 3px;
                }
                .text {
                    // $imageHeight: 140px;
                    $imageHeight: 0px;
                    $margin: 20px;
                    $topicHeight: 12px;
                    $headingHeight: 22px;
                    $headingGutter: 6px;
                    $teaserHeight: 12px;
                    $teaserGutter: 4px;

                    $headingLines: 2;
                    $teaserLines: 5;

                    $headingY: $imageHeight + $margin + $topicHeight + $margin;
                    $teaserY: $headingY + $headingLines * ($headingHeight + $headingGutter) - $headingGutter + $margin;

                    $height: $teaserY + $teaserLines * ($teaserHeight + $teaserGutter) - $teaserGutter;

                    $shapes: (
                        rect(#d8d8d8, 100%, $imageHeight, 0, 0),
                        rect($topicColor, 140px, $topicHeight, 0, $imageHeight + $margin)
                    );

                    $shapes: join(
                        $shapes,
                        lines($headingLines, $skeletonColor, 100%, $headingHeight, $headingGutter, 0, $headingY, 60%)
                    );
                    $shapes: join(
                        $shapes,
                        lines($teaserLines, $skeletonColor, 100%, $teaserHeight, $teaserGutter, 0, $teaserY, 30%)
                    );
                    //@include skeleton($shapes...);

                    height: $height;
                }
            }
        }
        // @include tablet {
        //   margin: -10px;
        //   display: flex;
        //   flex-direction: row;
        //   justify-content: center;
        //   .teaser {
        //     margin:  10px;
        //     margin-bottom: 10px;
        //     flex-grow: 0;
        //     flex-shrink: 0;
        //   }
        // }
    }
}

.vertical {
    .teasers {
        text-align: center;
        .teaser {
            margin-bottom: 50px;
            &:last-child {
                margin-bottom: 10px;
            }
            // @include mobile {
            //   width: 100% !important;
            //   max-width: 360px;
            //   display: inline-block;
            // }
            &.skeleton {
                .image {
                    padding-bottom: 57%; // ca. 9 / 16
                    background: $skeletonColor;
                    border-radius: 3px;
                    margin-bottom: 20px;
                    // @include tablet {
                    //   padding-bottom: initial;
                    //   margin-bottom: 0;
                    //   height: 180px;
                    //   width: 320px;
                    //   flex-basis: 320px;
                    //   flex-grow: 0;
                    //   flex-shrink: 0;
                    // }
                }
                .text {
                    // $imageHeight: 140px;
                    $imageHeight: 0px;
                    $margin: 20px;
                    $topicHeight: 12px;
                    $headingHeight: 22px;
                    $headingGutter: 6px;
                    $teaserHeight: 12px;
                    $teaserGutter: 4px;

                    $headingLines: 2;
                    $teaserLines: 5;

                    $headingY: $topicHeight + $margin;
                    $teaserY: $headingY + $headingLines * ($headingHeight + $headingGutter) - $headingGutter + $margin;

                    $height: $teaserY + $teaserLines * ($teaserHeight + $teaserGutter) - $teaserGutter;

                    $shapes: (rect(#d8d8d8, 100%, $imageHeight, 0, 0), rect($topicColor, 140px, $topicHeight, 0, 0));

                    $shapes: join(
                        $shapes,
                        lines($headingLines, $skeletonColor, 100%, $headingHeight, $headingGutter, 0, $headingY, 60%)
                    );
                    $shapes: join(
                        $shapes,
                        lines($teaserLines, $skeletonColor, 100%, $teaserHeight, $teaserGutter, 0, $teaserY, 30%)
                    );
                    //@include skeleton($shapes...);

                    height: $height;

                    // @include tablet {
                    //   flex-grow: 1;
                    //   margin-left: 20px;
                    // }
                }
                // @include tablet {
                //   display: flex;
                //   flex-direction: row;
                // }
            }
        }
    }
}

.horizontal {
    position: relative;
}

.spinner-container {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.2);
}
</style>
